module.exports = __webpack_public_path__ + "img/5_of_Diamonds.svg.f0002102.png";